var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBeigeBoat = function SvgBeigeBoat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 108,
    viewBox: "0 0 165 108",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9595 71.3513L0 50.2507L55.682 48.4924L43.9595 71.3513Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9595 71.3513L0 50.2507L55.682 48.4924L43.9595 71.3513Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.017 70.7654L107.261 47.9064L164.115 45.5619L126.017 70.7654Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.017 70.7654L107.261 47.9064L164.115 45.5619L126.017 70.7654Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9781 90.4634L82.2054 0.782089L133.029 73.3684L92.0009 96.4584L81.9781 90.4634Z",
    fill: "url(#paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2359 0L23.0534 68.7246L82.2359 88.9509V0Z",
    fill: "url(#beige_boat_paint3_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.472 0.570328L22.2895 69.2949L81.472 89.5213V0.570328Z",
    fill: "url(#beige_boat_paint4_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3557 98.7129L0.781494 51.188L77.5549 62.1836L164.897 46.499L147.518 94.3789L80.6506 108L19.3557 98.7129Z",
    fill: "url(#paint5_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5742 97.9307L0 50.4057L76.7734 61.4014L164.115 45.7167L146.736 93.5967L79.8691 107.218L18.5742 97.9307Z",
    fill: "url(#beige_boat_paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 6.03281,
    y1: 40.243,
    x2: 53.2898,
    y2: 70.9098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEDE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4F4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 154.842,
    y1: 41.2485,
    x2: 115.126,
    y2: 82.9755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEDE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4F4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 111.92,
    y1: -19.9319,
    x2: 97.1508,
    y2: 175.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFF6EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "beige_boat_paint3_linear",
    x1: 69.7468,
    y1: -25.7888,
    x2: 70.919,
    y2: 161.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEDE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557327,
    stopColor: "#5B4F4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "beige_boat_paint4_linear",
    x1: 106.077,
    y1: 16.6145,
    x2: 52.2844,
    y2: 147.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#FFF6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 82.8368,
    y1: 10.315,
    x2: 82.4484,
    y2: 164.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4F4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "beige_boat_paint6_linear",
    x1: -100.615,
    y1: 70.138,
    x2: 232.295,
    y2: 69.7472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6EE"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBeigeBoat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/beige_boat.bf28ac26.svg";
export { ForwardRef as ReactComponent };